var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canCreate())?_c('b-col',{staticClass:"text-right",attrs:{"xs":"2"}},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{ name: _vm.newEntityRouteName }}},[_vm._v(_vm._s(_vm.newEntityBtn))])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96f68582","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/CreateEntity.vue
// module id = null
// module chunks = 